"use client";

import * as React from "react";
import { Camera, Clock, Headset, Key } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Frustrated with insurance",
  description: "Meticulous diagnostic reviews and personalized wellness plans tailored to your specific health goals.",
  icon: Camera
}, {
  title: "Tired of 5-minute visits",
  description: "Unhurried consultations that prioritize your story, ensuring every concern is thoroughly addressed.",
  icon: Clock
}, {
  title: "Can’t get same-day care",
  description: "Industry-leading privacy standards ensuring your medical records and consultations remain confidential.",
  icon: Headset
}];
export default function PremiumService() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}